module.exports = __webpack_public_path__ + "static/media/knolling_SS_navy_small.38fe0920.jpg";